import React from 'react'
import {mocNormalTextStyle} from '../utils/styles'

function DigitalOtherTerminals({userProfile}) {

  if (userProfile?.forCosco) {
    return null
  }
  return <>
    <span style={{...mocNormalTextStyle, paddingTop: 17}}>For rail destinations, please make payment directly to the provider or their preferred online platform.</span>
    <span style={{...mocNormalTextStyle, paddingTop: 9}}>
              For other terminals and depots, please reach out to your local <a
        href="https://www.oocl.com/usa/eng/localinformation/localcontacts/Pages/default.aspx?site=usa&lang=eng"
        target="_blank" rel="noreferrer">contact</a>.</span>
  </>
}

export default DigitalOtherTerminals
